export default __webpack_public_path__ + "static/media/iMac Pro Front View Mockup.a02537e3.png";